import React, { useState, useEffect } from 'react';
import {
    Form,
    Input,
    Select,
    Row,
    Col,
    Button,
    Space,
    Modal,
    DatePicker,
    TimePicker,
    Table,
    Switch,
} from 'antd';
import { apiRequest } from '../../../service/apiRequest';
import { showSuccess, showError } from '../../../components/errorHandler';

import type { DatePickerProps } from 'antd';
import type { TimePickerProps } from 'antd';
import dayjs, { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import type { PopconfirmProps, TableColumnsType, InputRef } from 'antd';
import { DeleteOutlined, PlusOutlined, BarcodeOutlined } from '@ant-design/icons';

const { TextArea } = Input;
const { Option } = Select;


dayjs.extend(customParseFormat);

const dateFormatList = ['DD/MM/YYYY', 'DD/MM/YY', 'DD-MM-YYYY', 'DD-MM-YY'];


interface AddJobModalProps {
    visible: boolean;
    onCancel: () => void;
    onCreate: (data: any) => void; // Callback after successful submit
    // initialValues?: {
    //     sd_id?: number;
    //     sd_variant_id: number;
    //     sd_ledger_id: number;
    //     sd_sale_type: string;
    //     sd_manual_job_no: string;
    //     sd_trail_date: string;
    //     sd_trail_time: string;
    //     sd_mobile_no: string;
    //     sd_delivery_date: string;
    //     sd_delivery_time: string;
    //     sd_for_custmor: string;

    //     product_name: string;
    //     product_code: string;
    // } | null;
    // Use this:
    initialValues?: CartItem | null;
    isEditMode?: boolean;
}

interface CartItem {
    sale_id: string;
    sd_id: number;
    sd_sale_id: string;
    sd_variant_id: number;
    sd_ledger_id: number;
    sd_sale_type: string;
    sd_manual_job_no: string;
    sd_trail_date: string;
    sd_trail_time: string;
    sd_mobile_no: string;
    sd_delivery_date: string;
    sd_delivery_time: string;
    sd_for_custmor: string;
    sd_variant_code: string;
    sd_qty: number;
    sd_unit: number;
    sd_tailor_name: string;
    sd_measurement: string;
    sd_fabric_issued: string;


    product_name: string;
    product_code: string;
}

interface ProductRow {
    key: number;
    sr: number;
    product: string;
    sd_qty: number;
    sd_unit: string;
    sd_variant_code?: string;
    sd_tailor_name?: string;
    sd_measurement?: boolean;
    sd_fabric_issued?: boolean;
}

interface Ledger {
    ledger_id: number;
    ledger_first_name?: string;
    ledger_last_name?: string;
}


const AddJobModal: React.FC<AddJobModalProps> = ({
    visible,
    onCancel,
    onCreate,
    initialValues = null,
    isEditMode = false,
}) => {
    const [form] = Form.useForm();
    const [isModalClose, setIsModalClose] = useState(true);
    const [selectedDate, setSelectedDate] = useState<Dayjs | null>(null);
    const [time, setTime] = useState<Dayjs | null>(null);
    const [cartData, setCart] = useState<CartItem | null>(null);
    const [ledgers, setLedgers] = useState<Ledger[]>([]);
    const [tailorOptions, setTailorOptions] = useState<{ value: number; label: string }[]>([]);





    // Determine if submit button should be disabled based on form validation
    const isSubmitDisabled = () => {
        const errors = form.getFieldsError();
        return errors.some(({ errors }) => errors.length > 0);
    };
    const onChange: TimePickerProps['onChange'] = (time, timeString) => {
        console.log('Selected time:', timeString);
        setTime(time);
    };




    // Handle form submit
    const handleJobEntry = async (values: any) => {
        try {
            if (!initialValues) {
                showError("Missing initial values for job entry.");
                return;
            }

            const payload: any = {
                sd_manual_job_no: values.sd_manual_job_no,
                sd_trail_date: values.sd_trail_date,
                sd_trail_time: values.sd_trail_time,
                sd_mobile_no: values.sd_mobile_no,
                sd_delivery_date: values.sd_delivery_date,
                sd_delivery_time: values.sd_delivery_time,
                sd_for_custmor: values.sd_for_custmor,
                sd_sale_id: initialValues.sd_sale_id,
                sd_ledger_id: initialValues.sd_ledger_id,
                sd_variant_id: initialValues.sd_variant_id,
                sd_sale_type: initialValues.sd_sale_type,

                job_details: dataSource.map(row => ({
                    sd_variant_code: row.sd_variant_code || null,
                    sd_qty: row.sd_qty || null,
                    sd_unit: row.sd_unit || null,
                    sd_tailor_name: row.sd_tailor_name || null,
                    sd_measurement: row.sd_measurement ? 1 : 0,
                    sd_fabric_issued: row.sd_fabric_issued ? 1 : 0,
                })),


                ...(initialValues?.sd_id && { sd_id: initialValues.sd_id }),
            };

            // ✅ Add sd_qty, sd_amount, sd_sub_total only for product
            if (initialValues.sd_sale_type === 'product') {
                payload.sd_qty = values.sd_qty;
                payload.sd_amount = values.sd_amount;
                payload.sd_sub_total = values.sd_sub_total;
            }

            const url = isEditMode ? 'edit-job' : 'add-job';
            const method = isEditMode ? 'put' : 'post';

            const data = await apiRequest({
                method,
                url,
                data: payload,
            });

            onCreate(data);
            showSuccess(isEditMode ? 'Job Entry updated successfully!' : 'Job Entry created successfully!');
            form.resetFields();


            if (isModalClose) {
                onCancel();
            }

        } catch (error) {
            showError(`Failed to ${isEditMode ? 'update' : 'create'} Job Entry`);
        }
    };



    const handleChange: DatePickerProps['onChange'] = (date, dateString) => {
        console.log('Selected date object:', date);
        console.log('Formatted string:', dateString);
        setSelectedDate(date);
    };

    // const fetchLedgers = async () => {
    //     try {
    //         const response = await apiRequest({
    //             method: 'get',
    //             url: 'h-ledger-data',
    //         });

    //         // Fix: Set only the array, not the full object
    //         const ledgerArray = response.ledgers;

    //         if (Array.isArray(ledgerArray)) {
    //             setLedgers(ledgerArray);
    //         } else {
    //             setLedgers([]); // Fallback if unexpected
    //         }
    //     } catch (error) {
    //         showError('Failed to fetch ledger data');
    //         console.error(error);
    //     }
    // };




    const fetchLedgers = async () => {
        try {
            const response = await apiRequest({
                method: 'get',
                url: 'h-ledger-data?account_head=&account_sub_head=22',
            });

            const ledgerArray: Ledger[] = response.ledgers;

            if (Array.isArray(ledgerArray)) {
                const options = ledgerArray.map(ledger => ({
                    value: ledger.ledger_id,
                    label: `${ledger.ledger_first_name ?? ''} ${ledger.ledger_last_name ?? ''}`.trim(),
                }));
                setTailorOptions(options);
            } else {
                setTailorOptions([]);
            }
        } catch (error) {
            showError('Failed to fetch ledger data');
            console.error(error);
        }
    };


    useEffect(() => {
        fetchLedgers();
    }, []);

    const [dataSource, setDataSource] = useState<ProductRow[]>([
        {
            key: 1,
            sr: 1,
            product: '',
            sd_qty: 1,
            sd_unit: '',
            sd_variant_code: '',
            sd_tailor_name: '',
            sd_measurement: false,
            sd_fabric_issued: false
        },
    ]);




    const handleInputChange = (value: any, index: number, key: keyof ProductRow) => {
        const updatedData = [...dataSource];
        (updatedData[index] as any)[key] = value;
        setDataSource(updatedData);
    };


    const handleAddRow = () => {
        const newRow: ProductRow = {
            key: Date.now(),
            sr: dataSource.length + 1,
            product: '',
            sd_qty: 1,
            sd_unit: '',
            sd_variant_code: '',
            sd_tailor_name: '',
            sd_measurement: false,
            sd_fabric_issued: false,
        };
        setDataSource([...dataSource, newRow]);
    };


    const handleDelete = (key: number) => {
        setDataSource(prev => prev.filter(item => item.key !== key));
    };

    const columns: TableColumnsType<ProductRow> = [
        {
            title: 'Variant Code',
            dataIndex: 'sd_variant_code',
            key: 'sd_variant_code',
            width: 250,
            render: (_, record, index) => (
                <Input
                    placeholder="Scan or enter"
                    value={record.sd_variant_code}
                    onChange={e => handleInputChange(e.target.value, index, 'sd_variant_code')}
                    suffix={<BarcodeOutlined />}
                />
            ),
        },
        {
            title: 'Qty',
            dataIndex: 'sd_qty',
            key: 'sd_qty',
            width: 100,
            render: (_, record, index) => (
                <Input
                    type="number"
                    value={record.sd_qty}
                    onChange={e => handleInputChange(Number(e.target.value), index, 'sd_qty')}
                />
            ),
        },
        {
            title: 'Tailor Name',
            dataIndex: 'sd_tailor_name',
            key: 'sd_tailor_name',
            width: 200,
            render: (_, record, index) => (
                <Select
                    showSearch
                    allowClear
                    value={record.sd_tailor_name}
                    onChange={value => handleInputChange(value, index, 'sd_tailor_name')}
                    placeholder="Select Tailor"
                    style={{ width: '100%' }}
                    options={tailorOptions}
                    filterOption={(input, option) =>
                        (option?.label as string).toLowerCase().includes(input.toLowerCase())
                    }
                />
            ),
        },
        {
            title: 'Measurement',
            dataIndex: 'sd_measurement',
            key: 'sd_measurement',
            width: 120,
            align: 'center',
            render: (_, record, index) => (
                <Switch
                    checked={record.sd_measurement}
                    onChange={checked => handleInputChange(checked, index, 'sd_measurement')}
                />
            ),
        },
        {
            title: 'Fabric Issued',
            dataIndex: 'sd_fabric_issued',
            key: 'sd_fabric_issued',
            width: 120,
            align: 'center',
            render: (_, record, index) => (
                <Switch
                    checked={record.sd_fabric_issued}
                    onChange={checked => handleInputChange(checked, index, 'sd_fabric_issued')}
                />
            ),
        },
        {
            title: 'Action',
            key: 'action',
            width: 100,
            align: 'center',
            render: (_, record, index) => (
                <Button
                    danger
                    icon={<DeleteOutlined />}
                    onClick={() => handleDelete(record.key)}
                />
            ),
        },
    ];
    // Extra row for the "Add Row" button
    const footer = () => (
        <Button
            type="dashed"
            icon={<PlusOutlined />}
            style={{ width: '5%' }}
            onClick={handleAddRow}
        >

        </Button>
    );

    return (
        <Modal
            title={isEditMode ? 'Edit Job Entry' : 'Add New Job Entry'}
            visible={visible}
            onCancel={onCancel}
            footer={[
                <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                        setIsModalClose(true); // your custom logic
                        form.submit();         // manually trigger form submission
                    }}
                    disabled={isSubmitDisabled()}
                >
                    Save Job
                </Button>,
            ]}
            width="90%"
            destroyOnHidden
            maskClosable={false}
            centered
        >
            <Form
                form={form}
                layout="vertical"
                onFinish={handleJobEntry}
                autoComplete="off"
            >
                <Row gutter={16}>
                    {/* Manual Job No */}
                    <Col span={12}>
                        <Form.Item
                            name="sd_manual_job_no"
                            className='px-8'
                            label={
                                <span>
                                    Manual Job No.&nbsp;
                                    <span style={{ fontSize: '12px', color: '#888' }}>
                                        (Max 25 characters)
                                    </span>
                                </span>
                            }
                            rules={[
                                { required: true, message: 'Please enter the manual job no.' },
                                { max: 25, message: 'Maximum 25 characters allowed' },
                            ]}
                        >
                            <Input
                                showCount
                                maxLength={25}
                                placeholder="Enter Job Number "

                            />
                        </Form.Item>
                    </Col>

                    {/* trail date */}
                    <Col span={6}>
                        <Form.Item
                            name="sd_trail_date"
                            className='px-8 custom-date-picker'
                            label="Trial Date"
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                defaultValue={dayjs('01/01/2025', dateFormatList[0])}
                                format={dateFormatList}
                                onChange={handleChange}
                            />
                        </Form.Item>

                    </Col>

                    {/* trail time */}
                    <Col span={6}>
                        <Form.Item
                            name="sd_trail_time"
                            className='px-8 custom-date-picker'
                            label={
                                <span>
                                    Trial Time
                                </span>
                            }
                        >
                            <TimePicker
                                use12Hours
                                format="h:mm A"
                                onChange={onChange}
                                style={{ width: '100%' }}
                            />

                        </Form.Item>
                    </Col>

                    {/* Mobile number */}
                    <Col span={12}>
                        <Form.Item
                            name="sd_mobile_no"
                            label="Mobile Number"
                            className='px-8'
                            rules={[
                                { required: true, message: 'Required' },
                                { len: 10, message: 'Enter 10 digits' }
                            ]}

                        >
                            <Input maxLength={10} />
                        </Form.Item>
                    </Col>

                    {/* Delivery date */}
                    <Col span={6}>
                        <Form.Item
                            name="sd_delivery_date"
                            className='px-8 custom-date-picker'
                            label={
                                <span>
                                    Delivery Date
                                </span>
                            }
                        >
                            <DatePicker
                                style={{ width: '100%' }}
                                defaultValue={dayjs('01/01/2025', dateFormatList[0])}
                                format={dateFormatList}
                                onChange={handleChange}
                            />
                        </Form.Item>
                    </Col>

                    {/* Delivery time */}
                    <Col span={6}>
                        <Form.Item
                            name="sd_delivery_time"
                            className='px-8 custom-date-picker'
                            label={
                                <span>
                                    Delivery Time
                                </span>
                            }
                        >
                            <TimePicker
                                use12Hours
                                format="h:mm A"
                                onChange={onChange}
                                style={{ width: '100%' }}
                                className='custom-select-with-border ant-select-selector'
                            />

                        </Form.Item>
                    </Col>

                    <Col span={12}>
                        <Form.Item
                            name="sd_for_custmor"
                            label="For Customer"
                            className='px-8'
                            rules={[{ required: true }]}>
                            <Input />
                        </Form.Item>
                    </Col>
                </Row>


            </Form>
            {/* Table */}
            <div style={{ maxHeight: 'calc(100vh - 429px)', overflowY: 'auto', marginBottom: 16 }}>
                <Table<ProductRow>
                    sticky
                    columns={columns}
                    dataSource={dataSource}
                    pagination={false}
                    rowKey="sr"
                    bordered
                    footer={footer}
                    scroll={{ y: 'calc(100vh - 600px)' }}
                />
            </div>
        </Modal>
    );
};

export default AddJobModal;
